var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-container",attrs:{"id":"iframe-container"}},[(_vm.pdfBytes !== null)?_c('iframe',{style:(_vm.styleObj),attrs:{"id":"docViewerIframe","src":_vm.pdfObjectUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }